import * as React from 'react';

import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { createAncillariesAvailableEvent } from '@/scopes/checkout/domain/analytics/index';
import type { Services, ServiceType } from '@/scopes/checkout/domain/types';

export const useSendAncillaryAvailable = <K extends ServiceType>(service: Services[K] | null, result: string) => {
  const { sendEvent } = useAnalytics();
  const hasBeenSent = React.useRef(false);

  const sendAncillaryAvailableEvent = React.useCallback(() => {
    if (!service) return;
    sendEvent(
      createAncillariesAvailableEvent({
        result,
      })
    );
  }, [sendEvent, service, result]);

  React.useEffect(() => {
    if (hasBeenSent.current) return;
    if (!service) return;
    sendAncillaryAvailableEvent();
    hasBeenSent.current = true;
  }, [sendAncillaryAvailableEvent, hasBeenSent, service]);

  return {
    sendAncillaryAvailableEvent,
  };
};
